export const SLAColumns = [
    {
        name: 'Направление',
        key: 'direction',
    },
    {
        name: 'Тип SLA',
        key: 'type',
    },
    {
        name: 'Компания',
        key: 'company',
    },
    {
        name: 'Забор',
        key: 'pickup',
    },
    {
        name: 'Обработка',
        key: 'processing',
    },
    {
        name: 'Транзит',
        key: 'transit',
    },
    {
        name: 'Доставка',
        key: 'delivery',
    },
    {
        name: 'Тариф',
        key: 'tariff',
    },
    {
        name: 'Поставщик',
        key: 'supplier',
    },
    {
        name: 'Период',
        key: 'periodId',
    },
    {
        name: 'Активный',
        key: 'is_active',
    },
    {
        name: 'Контрольный срок (часы)',
        key: 'deadLineHours',
    },
]
